import { compose } from 'redux';
import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import { getTemplateFile } from 'redux-core/import-tracks-spreadsheet/actions';
import { userIdSelector } from 'redux-core/auth/selectors';
import {
  getSelectedProductionIdSelector,
  getSelectedProductionDivisionIdSelector,
} from 'redux-core/overview/selectors';

const paperProps = { sx: { transition: 'width 300ms ease' } };

/* BANDAID (goes with the resolver finishing backdrop): while /resolve is pending the
   drawer must not close — payload.finishing swaps onClose for a no-op, which covers
   Escape and outside clicks. The in-flight FINISH handler keeps the real onClose it
   captured at click time, so the programmatic close still works. */
const suspendedClose = () => {};

const mapStateToProps = (state, ownProps) => ({
  currentUserId: userIdSelector(state),
  productionId: getSelectedProductionIdSelector(state),
  divisionId: getSelectedProductionDivisionIdSelector(state),
  xlarge: ownProps.payload?.step === 'resolve',
  PaperProps: paperProps,
  ...(ownProps.payload?.finishing && { onClose: suspendedClose }),
});

const mapDispatchToProps = {
  getTemplateFile,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withBaseDrawer);
